import { strStartsWith } from '@patrianna/shared-utils/helpers'
import { skipOtpClosedSelector, skipOtpMandatorySelector } from '@patrianna-payments/shared-store/skip-otp'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import ROUTES from 'config/routes.json'
import { useAppSelector } from 'src/store/hooks'
import { navigateTo } from 'src/utils/browserLocation'
import { showOtpPageSelector } from 'store/modules/user/selectors'

const allowedPages = [
  ROUTES.SWEEPSTAKE_RULES,
  ROUTES.TERMS,
  ROUTES.RESPONSIBLE_PLAY,
  ROUTES.PRIVACY,
  ROUTES.OTP,
  ROUTES.COOKIE_POLICY,
  ROUTES.RIGHT_TO_OPT_OUT,
]

export default function useOtpRedirect() {
  const pathname = usePathname()
  const showOtpPage = useAppSelector(showOtpPageSelector)
  const closedOtpPage = useAppSelector(skipOtpClosedSelector)
  const isOtpMandatory = useAppSelector(skipOtpMandatorySelector)

  const isAllowedPage = allowedPages.some((route) => strStartsWith(route, pathname))
  const isClosed = closedOtpPage && !isOtpMandatory
  const isOtpRedirect = !isAllowedPage && showOtpPage && !isClosed

  useEffect(() => {
    if (isOtpRedirect) {
      navigateTo(ROUTES.OTP)
    }
  }, [isOtpRedirect])
}
